export enum ActionType {
    TOGGLE_TERMINAL_EXPANDED = '[CHR_CONTEXT] TOGGLE TERMINAL EXPANDED',
    SET_SELECTED_TAB_INDEX = '[CHR_CONTEXT] SET SELECTED TAB INDEX',
    SHOW_CLOSE_TERMINAL_MODAL = '[CHR_CONTEXT] SHOW CLOSE TERMINAL MODAL',
}
